import React from 'react';
import { Box, Typography, Link as MuiLink } from '@mui/material';
import { Link } from 'react-router-dom';
import { EntityFormLayoutProps } from './EntityFormLayout.types';
import GroupedFormSections from '../GroupedFormSections/GroupedFormSections';
import SaveButtons from '../SaveButtons/SaveButtons';
import Status from '../Status/Status';

const EntityFormLayout = <T,>({
    formConfig,
    formState,
    formHandlers,
    children,
    customFilterOptions,
    autocompleteInputChangeHandlers,
    autocompleteResetKeys,
    participantsActions
}: EntityFormLayoutProps<T>) => {
    const { title, icon, backUrl, headerActions } = formConfig || {};
    const { formData, groupedFields, groupIcons, groupOrder } = formState;
    const { handleSubmit, onChange, isLoading, isSuccess, isError, error, errorMessage, fieldErrors } = formHandlers;

    return (
        <form onSubmit={(e) => handleSubmit(e)}>
            {(title || backUrl) && (
                <Box mb={3}>
                    <Box display="flex" alignItems="center" gap={1}>
                        {icon}
                        <Typography variant="h4" fontWeight={600}>
                            {title}
                        </Typography>
                    </Box>
                    {(backUrl || headerActions) && (
                        <Box sx={{ mt: 1, display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
                            {backUrl && (
                                <MuiLink
                                    component={Link}
                                    to={backUrl}
                                    underline="hover"
                                    color="primary"
                                    sx={{ display: 'inline-block' }}
                                >
                                    ← Powrót
                                </MuiLink>
                            )}
                            {headerActions}
                        </Box>
                    )}
                </Box>
            )}

            <GroupedFormSections
                groupedFields={groupedFields}
                formData={formData}
                onChange={onChange}
                groupOrder={groupOrder}
                groupIcons={groupIcons}
                accordionMode
                fieldErrors={fieldErrors}
                customFilterOptions={customFilterOptions}
                autocompleteInputChangeHandlers={autocompleteInputChangeHandlers}
                autocompleteResetKeys={autocompleteResetKeys}
                participantsActions={participantsActions}
            />
            {children}
            <Box mt={3} mb={children ? 3 : 0}>
                <SaveButtons
                    handleSubmit={(_, shouldRedirect) => handleSubmit(new Event('submit') as any, shouldRedirect)}
                    isUpdating={isLoading}
                />
                <Status
                    isLoading={isLoading}
                    isSuccess={isSuccess}
                    isError={isError}
                    error={error}
                    errorMessage={errorMessage}
                />
            </Box>


        </form>
    );
};

export default EntityFormLayout;
